
import {changeFILE, clearFILE} from './file';
import {changeTEXT, sendCode, sendCodeInput} from './text';
import {changeTIME} from './time';
import {changeLIST, changeListOtherValue, changeCHECKBOX, clickLIST, clickListFocus} from './list';
import {changePOLICY} from './policy';
import {getFieldValue} from './custom';
import {FieldEvent, FieldError} from './settings';

export function createError(fieldName, cn) {
  FieldError[fieldName] = cn;
}

export function getFieldEvent(name){
  return FieldEvent[name];
}

export const fieldOperate = {
  changeFILE, clearFILE,
  changeTEXT, sendCode, sendCodeInput,
  changeTIME,
  changeLIST, changeListOtherValue, changeCHECKBOX, clickLIST, clickListFocus,
  changePOLICY,
  getFieldValue
};



